import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../hooks/use-services.hook";
import {TicketStationComponent} from "../common/ticket-station.component";
import {
    IJourneyShoppingCartViewModel
} from "../../../services/booking/models/shopping-cart/journey/journey-shopping-cart-view-model.interface";
import {HorizontalPlaneBox} from "../common/ticket-horizontal-plane.box";
import {TicketStandByLabelComponent} from "../common/ticket-standby-label.component";

interface TicketJourneyDetailsComponentProps {
    journeyCart: IJourneyShoppingCartViewModel;
}
export const TicketJourneyDetailsComponent: React.FC<TicketJourneyDetailsComponentProps> = observer((props) => {

    const services = useServices();
    const rootStyles: CSSProperties = {
        pageBreakInside: "avoid",
        breakInside: "avoid"
    }

    const gridStyles: CSSProperties = {
        display: 'grid',
        gridTemplateColumns: '1fr 3fr 1fr',
        padding: `${services.theme.currentTheme.spacing.cardDefaultPadding}`,
        backgroundColor: services.theme.currentTheme.colors.light,
        border: `1px solid ${services.theme.currentTheme.border.mainColor}`,
        borderRadius: services.theme.currentTheme.border.defaultRadius
    };

    const middleColumnStyles: CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        justifyContent: 'center',
        gap: "4px"
    };


    return (<div style={rootStyles}>
        <div style={gridStyles}>
            <TicketStationComponent station={props.journeyCart.designator.origin}
                                    departureDate={props.journeyCart.designator.formatDepartureDate()}
                                    departureTime={props.journeyCart.designator.formatDepartureTime()}/>
            <div style={middleColumnStyles}>
                {props.journeyCart.isStandBy && <TicketStandByLabelComponent/>}
                <HorizontalPlaneBox/>
            </div>

            <TicketStationComponent station={props.journeyCart.designator.destination}
                                    departureDate={props.journeyCart.designator.formatArrivalDate()}
                                    departureTime={props.journeyCart.designator.formatArrivalTime()}/>

        </div>
    </div>)
})